import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useMutateUnsuppressParentCompany() {
    const { oktaAuth } = useOktaAuth();

    const unsuppressParentCompany = async (requestData) => {
        const accessToken = oktaAuth.getAccessToken();
        
        const response = await axios.post(
            `api/ThirdPartyReceivable/UnsuppressParentCompany`,
            requestData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
            }
        );

        return response.data;
    };

    return useMutation({
        mutationFn: unsuppressParentCompany,
    });
}
